import { siteIconLetter } from "./siteFavicon";
import { siteDesignAttributes, type SiteDesign } from "./siteThemes";

type SiteIconProps = {
  design: SiteDesign;
  name: string;
  iconUrl: string | null;
};

/** The site icon as visitors see it: the upload, or a letter in the accent. */
export const SiteIcon = ({ design, name, iconUrl }: SiteIconProps) => (
  <span
    {...siteDesignAttributes(design)}
    aria-hidden="true"
    className="grid size-16 shrink-0 place-items-center overflow-hidden rounded-2xl border border-hazumu-border bg-site-accent text-site-bg"
  >
    {iconUrl ? (
      <img alt="" className="size-full object-cover" src={iconUrl} />
    ) : (
      <span className="site-heading text-3xl leading-none">
        {siteIconLetter(name)}
      </span>
    )}
  </span>
);
